/* eslint-disable filename-export/match-default-export */

import React, { useState } from 'react';
import pt from 'prop-types';
import { isNil } from 'lodash';
import cx from 'classnames';

import useValidators from '../../../hooks/use-validators';

import s from './code-editor-container.module.scss';

const CodeEditorContainer = ({
  name,
  value,
  label,
  errorMsg,
  validators,
  onBlur,
  onInput,
  onChange,
  readOnly,
  options,
  foldable,
  className,
  labelPosition = 'left',
  lang,
  rows = 20,
  testId = 'MrCodeEditor',
  CodeEditor,
  placeholder,
  onEditorMount,
}) => {
  const [hasFocus, setHasFocus] = useState();
  const { uuid } = useValidators({ validators });

  return (
    <div className={cx(className)}>
      {label && labelPosition === 'left' && (
        <label className={s.labelLeft} htmlFor={uuid}>
          {label}
        </label>
      )}

      {label && labelPosition === 'top' && (
        <div>
          <label className={s.labelTop} htmlFor={uuid}>
            {label}
          </label>
        </div>
      )}

      <div className={cx(hasFocus && s.hasFocus, errorMsg && s.hasError, s.container)}>
        <CodeEditor
          id={uuid}
          lang={lang}
          name={name}
          value={value}
          placeholder={placeholder ?? `Put Some ${lang} Code Here`}
          readOnly={readOnly}
          options={options}
          foldable={foldable}
          onChange={onChange}
          onBlur={event => {
            if (onBlur) {
              onBlur(event);
            }
            setHasFocus(false);
          }}
          onFocus={() => setHasFocus(true)}
          onInput={onInput}
          rows={rows}
          hasError={!isNil(errorMsg)}
          testId={testId}
          onEditorMount={onEditorMount}
        />
      </div>

      {errorMsg && <p className={s.errorMsg}>{errorMsg}</p>}
    </div>
  );
};

export const editorPropTypes = {
  value: pt.string,
  label: pt.string,
  name: pt.string.isRequired,
  onBlur: pt.func,
  onInput: pt.func,
  onChange: pt.func,
  errorMsg: pt.string,
  validators: pt.arrayOf(pt.func),
  className: pt.string,
  labelPosition: pt.oneOf(['top', 'left']),
  lang: pt.string.isRequired,
  rows: pt.oneOf([20, 30, 40]), // Similar to rows property for textarea.
  testId: pt.string,
  readOnly: pt.bool,
  CodeEditor: pt.elementType,
  placeholder: pt.string,
  // props only used for AceEditor
  foldable: pt.bool,
  options: pt.object,
  debounceChangePeriod: pt.number,
  // Called with the live ace editor instance after mount + internal
  // setup; AceCodeEditor only — other CodeEditor implementations are
  // free to ignore it.
  onEditorMount: pt.func,
};

CodeEditorContainer.propTypes = editorPropTypes;

export default CodeEditorContainer;
